import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageInfo from 'package.json';

import * as Sentry from '@sentry/angular';


if (environment.production) {
  enableProdMode();
  Sentry.init({
    environment: 'production',
    dsn: 'https://95e6227d0408f59e362a15267c7fccff@o4507690208198656.ingest.de.sentry.io/4507729279123536',
    release: packageInfo.version ?? 'Unknown version',
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration(),
      // Registers the Replay integration,
      // which automatically captures Session Replays
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled [/^https:\/\/yourserver\.io\/api/]
    tracePropagationTargets: [/^https:\/\/bwm\.bcas\.cz/, ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
